module.exports = __webpack_public_path__ + "img/cam-access-img.e7ed6e75.svg";